<template>
  <div>
    <Registerlayout>
      <h5 class="text-center">Member Login</h5>
      <form @submit.prevent="signin()" action="/" method="post">
        <div class="form-group">
          <label>Email</label>
          <input type="email" class="form-control" v-model="login.username" />
          <i class="icon_mail_alt"></i>
        </div>
        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            class="form-control"
            v-model="login.password"
          />
          <i class="icon_lock_alt"></i>
        </div>

        <div class="clearfix add_bottom_30">
          <div class="checkboxes float-left">
            <label class="container_check"
              >Remember me
              <input type="checkbox" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="float-right mt-1">
            <router-link  id="forgot" to="/forget-password" >Forgot Password?</router-link>
          </div>
        </div>
        <button
          type="submit"
          class="btn_1 rounded full-width"
          :disabled="loading"
        >
          <span
            v-show="loading"
            class="spinner-border spinner-border-sm"
          ></span>
          Login
        </button>
        <div class="text-center add_top_10">
          New to Travel Friends?
          <router-link to="/signup"
            ><strong><a href="signup">Sign up!</a></strong></router-link
          >
        </div>
        <div class="text-center add_top_10">
          Do you become a merchant?
          <router-link to="/merchant-signup"
            ><strong><a href="signup">Sign up!</a></strong></router-link
          >
        </div>
        
      </form>
    </Registerlayout>
  </div>
</template>

<script>
import API from "../services/index";
import Registerlayout from "../layouts/Registerlayout.vue";
//import router from "../routes";

export default {
  data() {
    return {
      token: null,
      role_id: null,
      balance:'0',
      expires_in: null,
      login: {
        username: "",
        password: "",
        grant_type: "password",
      },
      loading: false,
    };
  },
  beforeMount() {
    this.checkToken();
  },
  components: {
    Registerlayout,
  },
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");
      if (token != null) {
        if (roleId != 2 || roleId != 3) {
          this.$router.push("/dashboard");
        } else {
          this.$router.push("/my-account");
        }
      }
    },

    signin() {
      // const form = JSON.stringify(this.login);
      // console.log(form);
      this.loading = true;
      var formData = new FormData();
      formData.append("username", this.login.username);
      formData.append("password", this.login.password);
      formData.append("grant_type", "password");
      //form.append("grant_type", "password");
      API({
        method: "post",
        url: "user/login",
        data: formData,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      })
        .then((res) => {
          this.loading = false;
          this.login.email = "";
          this.login.passwordpassword = "";

          this.token = res.data.access_token;
          this.role_id = res.data.role_id;
          this.expires_in = res.data.expires_in;
          const expiresMs = this.expires_in * 1000;
          const now = new Date();
          const expireDate = new Date(now.getTime() + expiresMs);

          // router.push("/my-account");
          // alert(this.role_id);
          if (res.data.role_id == 2 || res.data.role_id == 3) {
            localStorage.setItem("token", this.token);
            localStorage.setItem("role_id", this.role_id);
            localStorage.setItem("expires", expireDate);
            localStorage.setItem("user_id", res.data.user_id);
            localStorage.setItem("location", res.data.location_data.address);
            localStorage.setItem("pincode", res.data.location_data.pincode);
            localStorage.setItem("lat", res.data.location_data.lat);
            localStorage.setItem("lng", res.data.location_data.lng);
            localStorage.setItem("balance", this.balance);
            localStorage.setItem(
              "user_status",
              res.data.location_data.is_active
            );

            this.$store.dispatch("login", expiresMs);
            this.$router.push("/offers-of-interest");
          } else {
            // alert('hello');
            if(res.data.message === "Verification Pending"){
              this.$router.push(`/verify/${window.btoa(this.login.username)}`);
              this.$swal("Error", "Please Verify your account first");
            }
            else{
              this.$swal("Error", res.data.message);
            }
            
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal("error", JSON.parse(err.request.responseText).error_description);
        });
    },
  },
};
</script>
